const $$splitComponentImporter = () => import('/home/runner/work/touring-host-app/touring-host-app/src/routes/_rootLayout/companies/$id.venues.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { getFindCompanySuspenseQueryOptions, getFindVenueSuspenseQueryOptions } from '@api';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_rootLayout/companies/$id/venues')({
  loader: ({
    context: {
      queryClient
    },
    params
  }) => {
    const {
      id: companyId
    } = params;
    queryClient.ensureQueryData(getFindCompanySuspenseQueryOptions(companyId)).then(companyResponse => {
      Promise.all(companyResponse.data.venueIds.map(venueId => queryClient.ensureQueryData(getFindVenueSuspenseQueryOptions(venueId))));
    });
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});